import { odata } from '../../conf';

export default {
  async loadDocumentStatuses({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('documentStatuses')
      .query({ $filter: 'IsDeleted eq false' });
    commit('SET_documentStatuses', data);
  },
  async createDocumentStatus({ commit, rootGetters, state }, documentStatus) {
    const data = await odata.o(rootGetters)
      .post('documentStatuses', documentStatus)
      .query();
    const { documentStatuses } = state;
    documentStatuses.push(data);
    commit('SET_documentStatuses', documentStatuses);
  },
  async updateDocumentStatus({ dispatch, rootGetters }, documentStatus) {
    await odata.o(rootGetters)
      .patch(`documentStatuses/${documentStatus.id}`, documentStatus)
      .query();
    dispatch('loadDocumentStatuses');
  },
};
